export const dashboardPaths = {
  // Brand > Search Performance
  searchPerformanceOverview: "/brand/search-performance/overview",
  searchPerformanceFunnel: "/brand/search-performance/traffic",
  searchPerformanceExplore: "/brand/search-performance/explore",
  searchPerformanceClusterManager: "/brand/search-performance/cluster-manager",
  searchPerformanceConversions: "/brand/search-performance/conversions",

  // Brand > Visibility
  visibilityOverview: "/brand/visibility/overview",
  visibilityCompetitors: "/brand/visibility/competitors",
  visibilitySearchTerms: "/brand/visibility/search-terms",
  visibilityAds: "/brand/visibility/ads",
  visibilityLocal: "/brand/visibility/local",

  // Brand > Campaign Leaks
  campaignLeaks: "/brand/campaign-leaks",

  // Non Brand
  nonBrandSearchPerformance: "/non-brand/search-performance",
  nonBrandVisibility: "/non-brand/visibility",
  nonBrandLegacyRoot: "/non-branded",

  // Competitors
  leaderboardMarketLeaders: "/competitors/leaderboard/market-leaders",
  leaderboardTrackedCompetitors: "/competitors/leaderboard/tracked-competitors",
  leaderboardCompetitorsSelection: "/competitors/leaderboard/competitors-selection",
  conquestMode: "/competitors/conquest-mode",

  // Legacy / misc
  trafficDetailsCountries: "/traffic-details/countries",
  competitorsMonitoring: "/competitors-monitoring",
  competitorFocus: "/competitor-focus",
  brandWayback: "/brand-wayback",
  competitorDomain: "/competitor/:domain",
  brandOverview: "/brand-overview",
  textAds: "/text-ads",
  productListingAds: "/product-listing-ads",
};

// Search Performance pages that share a persistent date range (override-persistence).
export const SEARCH_PERF_PERSISTENT_ROUTES = [
  dashboardPaths.searchPerformanceOverview,
  dashboardPaths.searchPerformanceFunnel,
  dashboardPaths.searchPerformanceExplore,
  dashboardPaths.searchPerformanceClusterManager,
];
